import _ from 'lodash';
import {
  createContext,
  useContext,
  useCallback,
  useState,
  type ReactNode,
} from 'react';

export enum StepId {
  DOCUMENTS_ID = 'documents',
  ROLE_REQUIREMENTS_ID = 'roleRequirements',
  PROFILE_ID = 'profile',
  REVIEW_ID = 'review',
}

interface StepsContextValue {
  completed: StepId[];
  setCompleted: (id: StepId) => void;
}

const StepsContext = createContext<StepsContextValue | null>(null);

export const StepsProvider = ({ children }: { children: ReactNode }) => {
  const [state, setState] = useState<StepId[]>([]);

  const setCompleted = useCallback(
    (id: StepId) => {
      const updated = _.uniq([...state, id]);
      setState(updated);
    },
    [state],
  );

  return (
    <StepsContext.Provider
      value={{
        setCompleted,
        completed: state,
      }}
    >
      {children}
    </StepsContext.Provider>
  );
};

export const useStepsCompleted = () => {
  const context = useContext(StepsContext);

  if (!context) {
    throw new Error('Missing StepsProvider');
  }

  return context;
};
